module.exports = __webpack_public_path__ + "static/media/slacklogo.25a488fe.jpg";